import { isColumnRequired } from '../utils/converters.js';

export default function RecordDetailPopup({
  open,
  title = 'レコード詳細',
  columns = [],
  row,
  readOnly = false,
  onClose,
  onSave,
  onDelete,
  saving = false,
  deleting = false,
  savingDisabled = false,
  errorMessage = '',
  renderField,
  formatValue,
}) {
  if (!open || !row) return null;

  const handleDelete = () => {
    if (!window.confirm('このレコードを削除しますか？')) return;
    onDelete?.(row);
  };

  return (
    <div className="db-entry-popup-overlay" role="presentation">
      <div
        className="db-entry-popup"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="db-entry-popup-header">
          <h3>{title}</h3>
          <div className="db-entry-popup-header-actions">
            {!readOnly && onDelete && row.id && (
              <button
                className="db-entry-popup-delete"
                disabled={deleting || saving}
                onClick={handleDelete}
                type="button"
              >
                {deleting ? '削除中...' : '削除'}
              </button>
            )}
            {!readOnly && onSave && (
              <button
                className="db-entry-popup-save"
                disabled={saving || savingDisabled}
                onClick={onSave}
                type="button"
              >
                {saving ? '保存中...' : '保存'}
              </button>
            )}
            <button className="db-entry-popup-close" onClick={onClose} type="button">
              {onSave ? 'キャンセル' : '完了'}
            </button>
          </div>
        </div>
        <div className="db-entry-popup-body">
          {errorMessage && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px',
              padding: '10px 14px', marginBottom: '12px', color: '#dc2626', fontSize: '13px',
              whiteSpace: 'pre-line',
            }}>
              {errorMessage}
            </div>
          )}
          {columns.filter((c) => !c.popupHidden).map((column) => (
            <div className="db-entry-popup-item" key={`popup-${column.key}`}>
              <div className="db-entry-popup-label">
                {column.label}
                {isColumnRequired(column, row) && <span className="required-mark">*</span>}
              </div>
              <div className="db-entry-popup-value">
                {readOnly || column.readOnly
                  ? (formatValue ? formatValue(column, row[column.key], row) : (row[column.key] ?? ''))
                  : renderField(row, column)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
